
<span v-show="visible" class="vnode__label" v-text="mappedName"></span>
